import { useState, useEffect } from "react";

// prop-types is a library for typechecking of props
import PropTypes from "prop-types";

import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import DialogTitle from "@mui/material/DialogTitle";
import NewUser from "views/users/new-user";

function EditUser({ showModal, signalCloseModal, id }) {
  const [open, setOpen] = useState(false);
  const [checkToclose, setCheckToclose] = useState(false);

  const handleCancelCreation = (update, name) => {
    // setOpen(false);
    // signalCloseModal(update, null);
    setCheckToclose(true);
  };

  const handleCloseCreation = (update, cancelData) => {
    if (!cancelData) {
      setOpen(false);
      signalCloseModal(update, null);
    }
    setCheckToclose(false);
  };

  
  useEffect(() => {
    setOpen(showModal);
  }, [showModal]);

  return (
    <div>
      <Dialog open={open} onClose={handleCancelCreation} fullWidth={true} maxWidth={"xl"}>
        <DialogTitle>Create New User</DialogTitle>
        <DialogContent>
          <NewUser id={id} signalCloseModal={handleCloseCreation} checkToClose={checkToclose} />
        </DialogContent>
      </Dialog>
    </div>
  );
}

// Setting default values for the props of CreatePlatform
EditUser.defaultProps = {
  showModal: true,
  signalCloseModal: () => {
    //console.log("close Modal");
  },
};

// Typechecking props of the CreatePlatform
EditUser.propTypes = {
  showModal: PropTypes.bool,
  signalCloseModal: PropTypes.func,
  id: PropTypes.number,
};

export default EditUser;
